import React from 'react'
import { useIntl } from 'react-intl';
import moment from 'moment';
import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { BookingDetailsIcon } from '../../..//Common/Assets/SvgComponent/SiteAdminSvgIcon';
import messages from '../../../../locale/messages';
import formatReservationState from '../../../../helpers/formatReservationState';

const ReservationDetails = ({ data }) => {
    const { formatMessage } = useIntl();
    let bookingType;
    if (data?.bookingType) bookingType = data?.bookingType?.charAt(0).toUpperCase() + data?.bookingType?.slice(1);

    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.bookingDetails)} icon={<BookingDetailsIcon />}>
                {data?.id && <ViewTableBodyInformation
                    title={formatMessage(messages.reservationId)}
                    value={data?.id}
                />}
                {data?.confirmationCode && <ViewTableBodyInformation
                    title={formatMessage(messages.confirmationCode)}
                    value={data?.confirmationCode}
                />}
                {data?.reservationState && <ViewTableBodyInformation
                    title={formatMessage(messages.reservationStatus)}
                    value={formatReservationState(data?.reservationState)}
                />}
                {data?.listData?.id && <ViewTableBodyInformation
                    title={formatMessage(messages.listingName)}
                    linkText={data?.listTitle ? data?.listTitle : data?.listData?.title}
                    linkData={"/rooms/" + data?.listData?.id}
                />}
                {data?.checkIn && <ViewTableBodyInformation
                    title={formatMessage(messages.checkInDate)}
                    value={moment(data?.checkIn).format("Do MMMM YYYY")}
                />}
                {data?.checkOut && <ViewTableBodyInformation
                    title={formatMessage(messages.checkOutDate)}
                    value={moment(data?.checkOut).format("Do MMMM YYYY")}
                />}
                <ViewTableBodyInformation
                    title={formatMessage(messages.bookingLength)}
                    value={`${data?.dayDifference} ${formatMessage(messages[data?.dayDifference > 1 ? 'nights' : 'night'])}`}
                />
                {bookingType && <ViewTableBodyInformation
                    title={formatMessage(messages.bookingMethod)}
                    value={bookingType}
                />}
                {data?.paymentMethodId && <ViewTableBodyInformation
                    title={formatMessage(messages.paymentMethod)}
                    value={data?.paymentMethodId == 1
                        ? formatMessage(messages.paypal)
                        : data?.paymentMethodId == 2
                            ? formatMessage(messages.stripe)
                            : data?.paymentMethodId == 3
                                ? formatMessage(messages.clickToPay)
                                : data?.paymentMethodId == 4
                                    ? 'Virement'
                                    : data?.paymentMethodId == 5
                                        ? 'Espèces'
                                        : 'N/A'}
                />}
            </ViewTableInformation>
        </div>
    )
}

export default ReservationDetails;
